export class InvalidFieldError extends Error {
  constructor (fieldType: string) {
    super(`O valor do campo deve ser um ${fieldType} válido`)
    this.name = 'InvalidFieldError'
  }
}
